module.exports = __webpack_public_path__ + "img/drag-icon.a179b4b5.svg";